import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { useHasGate } from '../';
export const HasGate = ({
  gate,
  fallback = /*#__PURE__*/_jsx(_Fragment, {}),
  children
}) => {
  const hasGate = useHasGate(gate);
  if (hasGate) return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: fallback
  });
};